<template>
    <div class="template">
        <navigation auth/>
        <div class="content" v-if="ready">
            <div v-if="files.play_url || files.download_url || files.contributions.length > 0">
                <div id="video" v-if="files.play_url">
                    <video :src="files.play_url" controls/>
                </div>
                <div id="links" v-if="files.download_url">
                    <a target="_blank" :href="files.download_url">
                        <button>{{ $t('pages.files.download')  }}</button>
                    </a>
                </div>
                <div id="contributions" v-if="files.contributions.length > 0">
                  <div class="contribution" v-for="contribution in files.contributions" :key="contribution.name">
                    <div class="title">{{ contribution.name }}</div>
                    <ol>
                      <li v-for="file in contribution.files" :key="file.download_url">
                        {{ formatDate(file.started_at) }} --> {{ formatDate(file.ended_at) }} <a :href="file.download_url" target="_blank"><button>{{ $t('pages.files.download')  }}</button></a>
                      </li>
                    </ol>
                  </div>
                </div>
            </div>
            <div v-else>
                <img src="~@/assets/img/files_deleted.svg"/>
                <div class="title" v-html="$t('pages.files.title')"></div>
                <div class="text">{{ $t('pages.files.text') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import auth from '@/services/auth'
import event from '@/services/event'
import logger from '@/services/logger'
import { wsApp } from '@/services/ws'

export default {
  data () {
    return {
      done: 0,
      files: {
        contributions: [],
        download_url: null,
        play_url: null
      },
      funcs: [],
      ready: false
    }
  },
  beforeDestroy () {
    // Unregister receiver
    wsApp.unregisterReceiver(this)
  },
  beforeMount () {
    // Open websocket
    auth.openWebSocket(wsApp)

    // Register receiver
    wsApp.registerReceiver(this)
  },
  created () {
    logger.setFields({
      event_id: this.$route.params.event_id
    })
  },
  mounted () {
    // Get files
    event.files(this.$route.params.event_id)
      .then(data => {
        // Update download url
        if (data.download_url) {
          this.funcs.push(function () {
            auth.urlWithAccessToken(data.download_url).then(function (url) {
              this.files.download_url = url
              this.onDone()
            }.bind(this))
          }.bind(this))
        }

        // Update play url
        if (data.play_url) {
          this.funcs.push(function () {
            auth.urlWithAccessToken(data.play_url).then(function (url) {
              this.files.play_url = url
              this.onDone()
            }.bind(this))
          }.bind(this))
        }

        // Loop through contributions
        if (data.contributions) {
          for (var idxContribution = 0; idxContribution < data.contributions.length; idxContribution++) {
            // Append contribution
            this.files.contributions.push({
              files: [],
              name: data.contributions[idxContribution].name
            })

            // Loop through files
            for (var idxFile = 0; idxFile < data.contributions[idxContribution].files.length; idxFile++) {
              // Append file
              this.files.contributions[idxContribution].files.push({
                ended_at: new Date(data.contributions[idxContribution].files[idxFile].ended_at * 1000),
                started_at: new Date(data.contributions[idxContribution].files[idxFile].started_at * 1000)
              })

              // Update download url
              this.updateContributionFileDownloadURL(data.contributions[idxContribution].files[idxFile].download_url, idxContribution, idxFile)
            }
          }
        }

        // Loop through funcs
        this.funcs.forEach(function (f) { f() })
      })
      .catch(err => logger.error(err))
  },
  methods: {
    updateContributionFileDownloadURL (downloadUrl, idxContribution, idxFile) {
      this.funcs.push(function () {
        auth.urlWithAccessToken(downloadUrl).then(function (url) {
          this.files.contributions[idxContribution].files[idxFile].download_url = url
          this.onDone()
        }.bind(this))
      }.bind(this))
    },
    onDone () {
      this.done++
      if (this.done >= this.funcs.length) this.ready = true
    },
    formatDate (date) {
      return String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0') + ':' + String(date.getSeconds()).padStart(2, '0')
    }
  }
}
</script>

<style scoped>

.content {
    padding-top: 3em;
}

.content img {
    height: 12em;
    margin-bottom: 3em;
}

.content .title {
    font-size: 2em;
    margin-bottom: 1em;
}

.content .text {
    font-size: 1em;
    margin-bottom: 2em;
}

#video {
  margin-bottom: 2em;
}

#video > video {
  max-height: 30em;
}

#contributions {
  padding: 2em;
  text-align: left;
}

#contributions .contribution {
  margin-bottom: 2em;
}

#contributions .contribution:last-child {
  margin-bottom: 0;
}

#contributions .contribution .title {
  margin-bottom: 0.5em;
}

#contributions .contribution ol {
  padding: 0 0 0 3em;
  margin: 0;
}

#contributions .contribution li {
  margin-bottom: 0.5em;
}

#contributions .contribution li:last-child {
  margin-bottom: 0;
}

#contributions .contribution a {
  margin-left: 1em;
}

</style>
